export const STAGE_KEY_IN_QUEUE = "IN_QUEUE";
export const STAGE_KEY_PREPARER_ASSIGNED = "PREPARER_ASSIGNED";
export const STAGE_KEY_PREP_IN_PROGRESS = "PREP_IN_PROGRESS";
export const STAGE_KEY_MISSING_INFORMATION = "MISSING_INFORMATION";
export const STAGE_KEY_REVIEW_IN_PROGRESS = "REVIEW_IN_PROGRESS";
export const STAGE_KEY_DRAFT_SHARED = "DRAFT_SHARED";
export const STAGE_KEY_READY_TO_FILE = "READY_TO_FILE";
export const STAGE_KEY_COMPLETED = "COMPLETED";
export const STAGE_KEY_ADD_DETAILS = "ADD_DETAILS";
export const STAGE_KEY_PRICING = "PRICING";
export const STAGE_KEY_AMENDMENT = "AMENDMENT";

export const ETD_HIDDEN_STAGE_KEYS: string[] = [
  STAGE_KEY_DRAFT_SHARED,
  STAGE_KEY_READY_TO_FILE,
  STAGE_KEY_COMPLETED,
];
